import { connectionHelper } from './connection-helper';
import { getAnalytics } from './get-analytics';
import { initFirebaseApp } from './init-firebase-app';

let connectionHelperInitialized = false;
let appInitialized = false;

export const initApp = () => {
  if (!appInitialized) {
    appInitialized = true;
  }
  const app = initFirebaseApp();
  getAnalytics(app);
  // getPerformanceMonitoring(app);

  if (!connectionHelperInitialized) {
    connectionHelperInitialized = true;
    connectionHelper();
  }

  return app;
};
